import React, { useRef, useState } from "react";
import "./App.css";
import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Project";
import Contact from "./pages/Contact";
import StickyMenu from "./components/StickyMenu";
import Experience from "./pages/Experience";
import { ReferenceContext } from "./providers/ReferenceProvider";
import { MenuContext } from "./providers/MenuProvider";
import { ThemeProvider } from "providers/ThemeProvider";
function App() {
  const homeRef = useRef<HTMLDivElement>(null);
  const aboutRef = useRef<HTMLDivElement>(null);
  const experienceRef = useRef<HTMLDivElement>(null);
  const projectRef = useRef<HTMLDivElement>(null);
  const contactRef = useRef<HTMLDivElement>(null);
  const [isHamburgerMenuOpen, setIsHamburgerMenuOpen] = useState(false);
  const menuState = { isHamburgerMenuOpen, setIsHamburgerMenuOpen };

  const [currentPageY, setCurrentPageY] = useState(0);
  const refs = {
    homeRef,
    aboutRef,
    experienceRef,
    projectRef,
    contactRef,
    currentPageY,
  };

  const onScroll = (e: any) => {
    // TODOS: add button at the bottom to suggest scrolling up to top
    setCurrentPageY(e.target.scrollTop);
  };

  return (
    <ReferenceContext.Provider value={refs}>
      <ThemeProvider>
        <MenuContext.Provider value={menuState}>
          <div className="scrollWrapper" id="scrollWrapper" onScroll={onScroll}>
            <Home isHomePage />
            <About />
            <Experience />
            <Projects />
            <Contact />
          </div>
          <StickyMenu />
        </MenuContext.Provider>
      </ThemeProvider>
    </ReferenceContext.Provider>
  );
}

export default App;
